module.exports = __webpack_public_path__ + "static/img/gai.c84fafa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/gai.jpg
// module id = 45pl
// module chunks = 1